export enum TaskMessages {
  ReeferShutDown = 'ReeferShutDown',
}

export enum TaskSubType {
  ReeferShutDown = 'ReeferShutDown',
  Custom = 'custom',
}
